// import Vue from 'vue';
import axios from 'axios'
import miniToastr from 'mini-toastr'
import { EventBus } from '../../../event-bus.js'

import configAll from '../../../../config/index.cjs'
import router from '../../../router/mental.js'

const config = configAll[process.env.NODE_ENV === 'production' ? 'build' : (process.env.NODE_ENV === 'prodlocal') ? 'prodlocal' : 'dev']

const API_URL = config.urlServerMental
const EXERCISE_URL = `${API_URL}api/men/exercises/`
const ADD_STEP_URL = `${API_URL}api/men/exercisestep/`
const ADD_PRACTICE_URL = `${API_URL}api/men/exercisepractice/`

export default {
  namespaced: true,
  state: {
    exercise: {},
    tags: [],
    items: [],
    totalItems: 0,
    cats: [],
    selectedCatId: 0,
    itemTags: []
  },
  mutations: {
    setCats (state, items) {
      // eslint-disable-next-line
      state.cats = items;
    },
    setCatId (state, catid) {
      // eslint-disable-next-line
      state.selectedCatId = catid;
    },
    setExercises (state, items) {
      items.rows.forEach((item) => {
        const tags = []
        item.Tags.forEach((tag) => {
          tags.push(tag.title)
        })
        // eslint-disable-next-line
        item.tags = tags.join(', ');
      })

      // eslint-disable-next-line
      state.items = items.rows;
      // eslint-disable-next-line
      state.totalItems = items.count;
    },
    setExercisesSimple (state, items) {
      // eslint-disable-next-line
      state.items = items;
      // eslint-disable-next-line
      state.totalItems = items.length;
    },
    setExerciseTags (state, items) {
      const tags = []
      items.forEach((item) => {
        if (item.Exercises.length) {
          tags.push(item)
        }
      })

      // eslint-disable-next-line
      state.itemTags = tags;
    },
    setExercisesByTag (state, items) {
      // eslint-disable-next-line
      const aa1 = items;

      aa1.forEach((item) => {
        const tags = []
        item.Tags.forEach((tag) => {
          tags.push(tag.title)
        })
        // eslint-disable-next-line
        item.tags = tags.join(', ');
      })
      EventBus.$emit('refresh-exercises', aa1)
    },
    search (state, data) {
      const aa1 = data
      aa1.rows.forEach((item) => {
        const tags = []
        item.Tags.forEach((tag) => {
          tags.push(tag.title)
        })
        // eslint-disable-next-line
        item.tags = tags.join(', ');
      })

      // eslint-disable-next-line
      state.items = aa1.rows;
      // eslint-disable-next-line
      state.totalItems = aa1.count;
    },
    addExercise (state, item) {
      // eslint-disable-next-line
      item.tags = '';
      // eslint-disable-next-line
      state.items.push(item);
      // eslint-disable-next-line
      state.totalItems++;
    },
    setExercise (state, item) {
      // eslint-disable-next-line
      // state.item = item;

      const aa1 = item
      // eslint-disable-next-line
      state.exercise = aa1;

      const tags = []
      aa1.Tags.forEach((tag) => {
        tags.push({ text: tag.title })
      })
      // eslint-disable-next-line
      state.tags = tags;
    },
    addStep (state, step) {
      if (state.exercise.ExerciseSteps) {
        // eslint-disable-next-line
        state.exercise.ExerciseSteps.push(step);
      } else {
        // eslint-disable-next-line
        state.exercise.ExerciseSteps = [step];
      }
      // console.log(state.item);
    },
    deleteStep (state, stepId) {
      const findStep = state.exercise.ExerciseSteps.find(item1 => item1.id === stepId)
      if (findStep) {
        const index = state.exercise.ExerciseSteps.indexOf(findStep)
        if (index > -1) {
          state.exercise.ExerciseSteps.splice(index, 1)
        }
      }
    },
    setTag (state, data) {
      // eslint-disable-next-line
      state.tags.push({ text: data.title });
      state.itemTags.push({ text: data.title })
    },
    deleteTag (state, data) {
      const findTag = state.tags.find(item1 => item1.text === data.title)
      if (findTag) {
        const indexTag = state.tags.indexOf(findTag)
        if (indexTag > -1) {
          state.tags.splice(indexTag, 1)
        }
      }

      const findTag1 = state.itemTags.find(item1 => item1.text === data.title)
      if (findTag1) {
        const indexTag = state.itemTags.indexOf(findTag)
        if (indexTag > -1) {
          state.itemTags.splice(indexTag, 1)
        }
      }
    },
    addPractice (state, qa) {
      // console.log('add step');
      if (state.exercise.ExercisePractices) {
        // eslint-disable-next-line
        state.exercise.ExercisePractices.push(qa);
      } else {
        // eslint-disable-next-line
        state.exercise.ExercisePractices = [qa];
      }
    },
    deletePractice (state, practiceId) {
      const findQuestion = state.exercise.ExercisePractices.find(item1 => item1.id === practiceId)
      if (findQuestion) {
        const index = state.exercise.ExercisePractices.indexOf(findQuestion)
        if (index > -1) {
          state.exercise.ExercisePractices.splice(index, 1)
        }
      }
    }
  },
  actions: {
    getCats ({ commit }) {
      axios.get(`${API_URL}api/mental/exercisescat`)
        .then((response) => {
          commit('setCats', response.data)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Get Cats failed!', 1500);
        })
    },
    getExercises ({ commit }, opts) {
      const offset = (opts.currentPage - 1) * opts.perpage
      const limit = opts.perpage
      const query = `offset=${offset}&limit=${limit}`
      axios.get(`${EXERCISE_URL}bycat/${opts.catid}?${query}`)
        .then((response) => {
          // eslint-disable-next-line
          commit('setExercises', response.data);
          if (opts.fromSidebar) {
            EventBus.$emit('refresh-exercises', response.data.rows)
          }
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Get Exercises failed!', 1500);
        })
    },
    getExercisesByTag ({ commit }, id) {
      const offset = 0
      const limit = 200
      axios.get(`${API_URL}api/mental/exercises/exercisesByTag/${id}?offset=${offset}&limit=${limit}`)
        .then((response) => {
          commit('setExercisesByTag', response.data)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Get Exercises by Tags failed!', 1500);
        })
    },
    getExerciseTags ({ commit }, catid) {
      axios.get(`${API_URL}api/mental/tag/exercise/${catid}`)
        .then((response) => {
          // eslint-disable-next-line
          commit('setExerciseTags', response.data);
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Get Exercise Tags failed!', 1500);
        })
    },
    getExercise ({ commit }, id) {
      axios.get(`${EXERCISE_URL}${id}`)
        .then((response) => {
          // eslint-disable-next-line
          commit('setExercise', response.data);
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Get Exercise Details failed!', 1500);
        })
    },
    addExercise ({ commit }, payload) {
      axios.post(EXERCISE_URL, payload)
        .then((response) => {
          commit('addExercise', response.data)
          miniToastr.success('Added Exercise!', '', 1500)
        })
        .catch((err) => {
          // eslint-disable-next-line
          context.error = err.data;
        })
    },
    // eslint-disable-next-line
    editExercise ({ commit }, payload) {
      axios.put(EXERCISE_URL, payload, { params: { id: payload.id } })
        .then(() => {
          EventBus.$emit('close-modal')
          miniToastr.success('Edited Exercise', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Edit Exercise failed!', 1500)
        })
    },
    // eslint-disable-next-line
    deleteExercise ({ commit }, exerciseId) {
      axios.delete(`${API_URL}api/mental/exercises/${exerciseId}`)
        .then(() => {
          miniToastr.success('Deleted Exercise', '', 1500)
          router.replace('/tickets')
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Delete Exercise failed!', 1500)
        })
    },
    // eslint-disable-next-line
    editExerciseOrder ({ commit }, payload) {
      axios.put(EXERCISE_URL, payload, { params: { id: payload.id } })
        .then(() => {
          EventBus.$emit('close-modal')
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Edit Exercise Order failed!', 1500)
        })
    },
    addStep ({ commit }, payload) {
      axios.post(ADD_STEP_URL, payload)
        .then((response) => {
          commit('addStep', response.data)
          miniToastr.success('Added Step', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Add Step failed!', 1500)
        })
    },
    // eslint-disable-next-line
    editStep ({ commit }, payload) {
      axios.put(ADD_STEP_URL, payload, { params: { id: payload.id } })
        .then(() => {
          // commit('editStep', response.data);
          EventBus.$emit('close-modal')
          miniToastr.success('Edited Question', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Edit Step failed!', 1500)
        })
    },

    deleteStep ({ commit }, stepId) {
      axios.delete(`${API_URL}api/mental/exercisestep/${stepId}`)
        .then(() => {
          commit('deleteStep', stepId)
          EventBus.$emit('hide-dialog')
          miniToastr.success('Deleted Step', '', 1500)
          // context.$modal.hide('dialog');
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Delete Step failed!', 1500)
        })
    },
    search ({ commit }, opts) {
      const offset = (opts.currentPage - 1) * opts.perpage
      const limit = opts.perpage
      const query = `catid=${opts.catid}&term=${encodeURI(opts.term)}&offset=${offset}&limit=${limit}`
      axios.get(`${API_URL}api/mental/exercises/two/search?${query}`).then((response) => {
        commit('search', response.data)
      }).catch((err) => {
        miniToastr.error(err.response.data.errorMessage, 'Search failed!', 1500)
      })
    },
    addTag ({ commit }, tag) {
      axios.post(`${API_URL}api/mental/tag/exercise/link`, tag)
        .then((response) => {
          commit('addTag', { exercise_id: tag.exercise_id, title: response.data.title })
          miniToastr.success('Added Tag!', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Add Tag failed!', 1500)
        })
    },
    deleteTag ({ commit }, tag) {
      axios.post(`${API_URL}api/mental/tag/exercise/link/rm`, tag)
        .then((response) => {
          commit('deleteTag', response.data)
          miniToastr.success('Deleted Tag!', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Delete Tag failed!', 1500)
        })
    },
    addPractice ({ commit }, payload) {
      axios.post(ADD_PRACTICE_URL, payload)
        .then((response) => {
          commit('addPractice', response.data)
          miniToastr.success('Added Practice', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Add Practice failed!', 1500)
        })
    },
    // eslint-disable-next-line
    editPractice ({ commit }, payload) {
      axios.put(ADD_PRACTICE_URL, payload, { params: { id: payload.id } })
        .then(() => {
          // commit('editStep', response.data);
          EventBus.$emit('close-modal')
          miniToastr.success('Edited Practice', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Edit Practice failed!', 1500)
        })
    },
    deletePractice ({ commit }, practiceId) {
      axios.delete(`${API_URL}api/mental/exercisepractice/${practiceId}`)
        .then(() => {
          commit('deletePractice', practiceId)
          EventBus.$emit('hide-dialog')
          miniToastr.success('Deleted Practice', '', 1500)
          // context.$modal.hide('dialog');
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Delete Practice failed!', 1500)
        })
    },
    // eslint-disable-next-line
    editStepOrder ({ commit }, payload) {
      axios.put(ADD_STEP_URL, payload, { params: { id: payload.id } })
        .then(() => {
          EventBus.$emit('close-modal')
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Edit Step Order failed!', 1500)
        })
    }
  },
  getters: {}
}
